import { IonPage } from "@ionic/react";

export default function ResetPassword() {
  return <IonPage>Reset password</IonPage>;
}
